module.exports = __webpack_public_path__ + "img/ico_consulta-valor.51f72fac.svg";